const JobseekersIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44336 4.68125C9.44336 3.8045 10.1541 3.09375 11.0309 3.09375H18.9684C19.8451 3.09375 20.5559 3.8045 20.5559 4.68125V6.26875H28.2409L24.8301 14.7958C24.589 15.3985 24.0053 15.7937 23.3561 15.7937H18.9684V15.2646C18.9684 14.6801 18.4945 14.2062 17.91 14.2062H12.0892C11.5047 14.2062 11.0309 14.6801 11.0309 15.2646V15.7937H6.64308C5.99394 15.7937 5.41021 15.3985 5.16912 14.7958L1.75829 6.26875H9.44336V4.68125ZM18.9684 6.26875H11.0309V5.18125C11.0309 4.90511 11.2547 4.68125 11.5309 4.68125H18.4684C18.7445 4.68125 18.9684 4.90511 18.9684 5.18125V6.26875Z"
        fill="black"
      />
      <path
        d="M25.8127 15.1889L28.4934 8.48733V25.3187C28.4934 26.1955 27.7826 26.9062 26.9059 26.9062H3.09336C2.21661 26.9062 1.50586 26.1955 1.50586 25.3187V8.48732L4.18648 15.1889C4.58829 16.1934 5.56119 16.8521 6.64308 16.8521H11.0309V17.9104C11.0309 18.4949 11.5047 18.9687 12.0892 18.9687H17.91C18.4945 18.9687 18.9684 18.4949 18.9684 17.9104V16.8521H23.3561C24.438 16.8521 25.4109 16.1934 25.8127 15.1889Z"
        fill="black"
      />
      <path
        d="M12.0892 15.4646C12.0892 15.3541 12.1787 15.2646 12.2892 15.2646H17.71C17.8205 15.2646 17.91 15.3541 17.91 15.4646V17.7104C17.91 17.8209 17.8205 17.9104 17.71 17.9104H12.2892C12.1787 17.9104 12.0892 17.8209 12.0892 17.7104V15.4646Z"
        fill="black"
      />
    </svg>
  );
};

export default JobseekersIcon;
